// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button--text {\n  padding: 0;\n}\n.orderState {\n  border-radius: 10px;\n  border: 1px solid #dedede;\n  padding: 10px;\n  display: flex;\n  background-color: #f7f8fa;\n  justify-content: space-between;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
